import api from "@/api.js";

export default {
  state: {
    magazines: [],
    magazinesLoading: false
  },
  mutations: {
    setMagazines(state, payload) {
      state.magazines = payload;
    },
    setMagazinesLoading(state, loading) {
      state.magazinesLoading = loading;
    }
  },
  actions: {
    async loadMagazines({ commit, state }) {
      commit("setMagazinesLoading", true);
      let magazines = await api.get("magazines");
      commit("setMagazines", magazines.data);
      commit("setMagazinesLoading", false);
    },
    async saveMagazine({ commit, dispatch }, payload) {
      let returnData;
      await api
        .put("magazines", payload)
        .then(result => {
          returnData = {
            Result: "Success",
            Response: result
          };
          return returnData;
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
          return returnData;
        });
      dispatch("loadMagazines");
      return returnData;
    },
    async newMagazine({ commit, dispatch }, payload) {
      let returnData;
      await api
        .post("magazines", payload)
        .then(result => {
          returnData = {
            Result: "Success",
            Response: result,
            id: result.data.magazines_id
          };
          return returnData;
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
          return returnData;
        });

      return returnData;
    },
    async magazinesUpload({ commit }, payload) {
      let returnData;
      await api
        .post("magazines/upload", payload)
        .then(result => {
          returnData = {
            Result: "Success",
            Response: result
          };
          return returnData;
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
          return returnData;
        });
      return returnData;
    }
  },
  getters: {
    magazines(state) {
      return state.magazines;
    },
    magazinesLoading(state) {
      return state.magazinesLoading;
    }
  }
};
